<style lang="scss" scoped>
.scope {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  height: 100%;
}
.scope-header {
  background: whitesmoke;

  &:hover{
    background: #374a8a1c;
  }
}
@media screen and (min-width: 601px) {
  .example {
    font-size: 80px;
  }
}

@media screen and (max-width: 600px) {
  .example {
    font-size: 30px;
  }
}
</style>
<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ props }">
      <section class="my-3 scope-header" v-bind="props">
        <DialogComponent v-model="showBackConfirm" :value="showBackConfirm">
          <template v-slot:header>{{ $t("titles.confirmMessage") }}</template>

          <template v-slot:body>
            <span class="font-weight-bold">{{ $t("messages.sureBack") }}</span>
          </template>

          <template v-slot:actions>
            <v-btn class="primary mx-1 white--text" @click="navigateUrl">
              {{ $t("buttons.confirm") }}
            </v-btn>

            <v-btn class="secondary white--text" @click="showBackConfirm = false">
              {{ $t("buttons.cancel") }}
            </v-btn>
          </template>
        </DialogComponent>

        <div
          class="font-weight-bold px-3 scope clickable align-center"
          @click="goToNavigateUrl"
        >
          <v-icon :class="scopeIconStyle">mdi-office-building</v-icon>
          <v-breadcrumbs v-if="courseName" :items="breadcrumbItems" class="px-0">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item>
                {{ $utils.servertranslate(course.ScopeName) }} - {{ item.title }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </div>
      </section>
    </template>
    <span>{{ $t("messages.CHANGE_SCOPE") }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DialogComponent from '@/components/dialog.component.vue';
import CoursesProvider from '../providers/courses.provider';
import { CourseBasic, CourseDataResponse } from '../types/course.type';

export default defineComponent({
  name: 'SelectedCourse',
  components: {
    DialogComponent,
  },
  props: {
    appId: {
      type: String,
      required: true,
    },
    routeName: {
      type: String,
      required: true,
    },
    goBackWithConfirmMsg: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      course: {} as CourseBasic,
      showBackConfirm: false,
    };
  },
  computed: {
    courseId(): string {
      return this.$route.params.courseId;
    },
    breadcrumbItems() {
      if (!this.course?.courseName) return [];

      return [
        {
          title: this.$utils.servertranslate(this.course.courseName),
          disabled: true,
        },
      ];
    },
    courseName() {
      return this.course.courseName;
    },
    scopeIconStyle(): string {
      return this.$store.state.lang.lang === 'en' ? 'mr-4' : 'ml-4';
    },
  },
  mounted() {
    this.fetchCourse();
  },
  methods: {
    async fetchCourse() {
      const { course }: CourseDataResponse = await CoursesProvider.getCourseView(
        this.appId,
        this.courseId,
        { onlyInfo: true },
      );
      this.course = course;
      this.$emit('update:course', { ...this.course });
    },
    navigateUrl() {
      const { courseFilters } = this.$store.state.filters;
      this.$router.push({ name: this.routeName, query: courseFilters });
    },
    goToNavigateUrl() {
      if (this.goBackWithConfirmMsg) {
        this.showBackConfirm = true;
      } else {
        this.navigateUrl();
      }
    },
  },
});
</script>
